import { useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';
import { arrivalKeyForPath, forgetArrival } from '../lib/arrivals';
import { useAuth } from '../context/AuthContext';

/**
 * Arrival covers show once. This is how someone gets one back, sits quietly in
 * the corner and only appears on a page that actually has an overview.
 */
export const ArrivalReplay = () => {
  const { pathname } = useLocation();
  const { token } = useAuth();
  const key = arrivalKeyForPath(pathname);
  if (!key) return null;

  return (
    <button
      onClick={async () => { await forgetArrival(key, token); window.location.reload(); }}
      data-testid="arrival-replay-btn"
      title="Show this page's overview again"
      className="group inline-flex items-center gap-1.5 text-[11px] text-slate-300 hover:text-cyan-300
                 border border-white/10 hover:border-cyan-300/40 rounded-full px-2.5 py-1
                 transition-colors duration-200">
      <Info className="w-3 h-3" />
      <span className="hidden sm:inline">Page overview</span>
    </button>
  );
};

export default ArrivalReplay;
